import {noop} from '@/utils/functions';

export const useCodePushSyncQuery = () => noop;
